export default __webpack_public_path__ + "static/media/asensiot_logo_green.6c171033.svg";